<script setup lang="ts">
import { computed, defineProps, onMounted, ref, watch } from 'vue';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import DraftFileIcon from '@/dashboard/vue/components/icons/DraftFileIcon.vue';
import { Draft } from '@/dashboard/types/draft';
import { formatBytes } from '@/dashboard/utils/formatBytes';
import { DraftsApi } from '@/dashboard/api/drafts';
import DraftUploadingLoader from '@/dashboard/vue/components/draft/_components/DraftUploadingLoader.vue';

const props = defineProps<{
  draft: Draft;
}>();

const extension = computed(() => props.draft.name.split('.').pop());
const downloadLink = ref('');

watch(props, async () => {
  if (props.draft.file) {
    const urlResponse = await DraftsApi.getDownloadUrl({
      short_link: props.draft.short_link,
      filename: encodeURIComponent(props.draft.name),
    });
    downloadLink.value = urlResponse.url ?? '';
  }
});

onMounted(async () => {
  if (props.draft.file) {
    const urlResponse = await DraftsApi.getDownloadUrl({
      short_link: props.draft.short_link,
      filename: encodeURIComponent(props.draft.name),
    });
    downloadLink.value = urlResponse.url ?? '';
  }
});
</script>

<template>
  <div v-if="draft.file && draft.draft_size > 0" class="text-caption-s flex flex-1 items-center justify-center p-s text-black dark:text-gray-500">
    <div class="flex h-[458px] w-[343px] flex-col justify-between rounded-[32px] bg-gray-200 dark:bg-gray-950 laptop:h-[527px] laptop:w-[384px]">
      <div class="wrap-anywhere px-xxl">
        <div class="mb-s flex items-start justify-center">
          <div class="relative mt-[72px] laptop:mt-[112px]">
            <draft-file-icon class="drop-shadow-s-hover" />
            <div
              class="text-buttons absolute bottom-m right-zero line-clamp-1 flex h-[26px] bg-brand-night-blue px-[14px] text-white dark:text-black"
            >
              .{{ extension }}
            </div>
          </div>
        </div>
        <div class="mb-[38px] line-clamp-3 break-words text-center">
          {{ draft.name }}
        </div>
      </div>

      <div class="flex w-full flex-col gap-y-[12px] pb-l">
        <Divider class="w-full" />
        <div class="flex w-full flex-col gap-y-[12px] px-l text-center">
          <span>{{ formatBytes(draft.draft_size) }} / .{{ extension }}</span>
          <a v-if="downloadLink.length > 0" :href="downloadLink" target="_blank" class="tppr-button min-h-[64px] w-full">
            <span class="tppr-button__text">↓ Download file</span>
          </a>
          <button v-else :disabled="true" class="tppr-button min-h-[64px] w-full">
            <span class="tppr-button__text">Uploading...</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <DraftUploadingLoader v-else />
</template>
